const commoditySection = {
  path: 'commoditySection',
  name: 'commoditySection',
  meta: {
    menuCode: 'agentCommoditySection'
  },
  component: () => import('@/views/agent/commoditySection/commodity-section.vue')
};
export default commoditySection;
